import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import {
  CrudMasterDetailView,
  CompositeView,
  CrudContext,
  GridView,
  MasterDetailForm,
  Widget,
  FormatText,
  FormInput,
  FormDatePicker,
  FormSubmitButton,
  Button,
} from '@digital/ui';

import {
  createCrfPlanilhaRfa,
  GetAllCrfPlanilhaRfaAntigas,
  getAllCrfProjetosPlanilhaCapexModulo
} from '@app/api/crf/crfProjeto';
import { CrfOrcamentoPlanilha } from '@app/api/crf/crfOrcado';

import { hasPermission } from '@app/helpers/permissions';
import UploadFile from '@app/components/uploadFile';

import CrfTablePlanilha from '../CrfTablePlanilhas';
import CrfPlanilhaRfaTabela from './CrfPlanilhaRfaTabela';
import { exportaCrfModelo, exportaCrfPlanilhaRfaAnoMes, exportaCrfPlanilhaRfaAntiga } from '@app/api/crf/crfExportaFile';
import { EExportarModeloCrf } from '@app/enums/EExportarModeloCrf';

const CrfPlanilhaRfa = () => {
  const [projetos, setProjetos] = useState(() => getAllCrfProjetosPlanilhaCapexModulo);
  const [hasFile, setHasFile] = useState(false);
  const [atualizarTela, setAtualizarTela] = useState<boolean>(false);
  const [planilhas, setPlanilhas] = useState<CrfOrcamentoPlanilha[]>();
  const [projetoSelecionado, setProjetoSelectionado] = useState<CrfOrcamentoPlanilha>();

  useEffect(() => {
    const getProjetoData = async () => {
      const result: any = await getAllCrfProjetosPlanilhaCapexModulo();
      if (result) setProjetos(result);
    };

    getProjetoData();
  }, []);

  useEffect(() => {
    const getPlanilhasData = async (id: string) => {
      const result = await GetAllCrfPlanilhaRfaAntigas(id);
      if (result) setPlanilhas(result);
    };

    if (projetoSelecionado) getPlanilhasData(projetoSelecionado.id);
  }, [projetoSelecionado]);

  const handleCreatePlanilhaOrcamento = (values: any, selectedItem: any) => {
    createCrfPlanilhaRfa(selectedItem.id, values.formData, values).then((result: any) => {
      if (result && result.valid) {
        setHasFile(true);
        setHasFile(false);
        setAtualizarTela(!atualizarTela);
        setProjetos(() => Promise.resolve(undefined));
        setProjetos(() => getAllCrfProjetosPlanilhaCapexModulo);
      }
    });
  };

  const hasPlanilhaRfa = (planilha: boolean) => {

  };

  const exportarPlanilha = (item: CrfOrcamentoPlanilha) => {
    if (item) {
      exportaCrfPlanilhaRfaAntiga(item.projetoId, item.nome, item.numero, item.revisao, item.dataAprovacao);
    }
  };

  const validationSchema = Yup.object().shape({
    dataAprovacao: Yup.date().required('Data de Aprovação é obrigatória.'),
  });

  return (
    <CrudMasterDetailView
      getAllItems={projetos}
      disableNotification
      icon="business-estimate"
      detailTitleExtractor={x => `PLANILHA ORÇADO RFA DO PROJETO ${x.numero}`}
      filterPredicate={(item, value) =>
        item.nome.toLowerCase().includes(value.toLowerCase()) ||
        (item.codigo && item.codigo.toLowerCase().includes(value.toLowerCase())) ||
        (item.statusNome && item.statusNome.toLowerCase().includes(value.toLowerCase())) ||
        item.numero.toLowerCase().includes(value.toLowerCase())
      }
      titleExtractor={item => `${item.codigo} - ${item.nome}`}
      descriptionExtractor={item => item.statusNome || ''}>
      <CompositeView>
        {hasPermission(['Dono', 'ORCADO_ECONOMICO_RFA_VISUALIZAR_MENU']) && (
          <CrudContext.Consumer>
            {({ selectedItem }) => {
              setProjetoSelectionado(selectedItem);
              return (
                <GridView noform>
                  {hasPermission(['ORCADO_ECONOMICO_RFA_EDITAR_ABA_INDEX']) && (
                    <MasterDetailForm
                      validationSchema={validationSchema}
                      onSubmit={values => {
                        handleCreatePlanilhaOrcamento(values, selectedItem);
                      }}>
                      <Widget
                        title="Importação de planilha"
                        actions={[
                          selectedItem && selectedItem.possuiPlanilhaCapex === true && (
                            <Button
                              type="link"
                              icon="files-xls"
                              onClick={() => {
                                exportaCrfPlanilhaRfaAnoMes(selectedItem.id, 'planilhaRfa.xlsx');
                              }}>
                              Exportar Planilha
                            </Button>
                          ),
                          <Button
                            type="link"
                            icon="files-xls"
                            onClick={() => {
                              exportaCrfModelo(EExportarModeloCrf.MODELO_IMPORTACAO_RFA);
                            }}>
                            Modelo de importação RFA
                          </Button>,
                          hasPermission(['ORCADO_ECONOMICO_RFA_EDITAR_ABA_INDEX']) && (
                            <FormSubmitButton type="primary">
                              <FormatText id="ui.commons.save" uppercase />
                            </FormSubmitButton>
                          ),
                        ]}>
                        <FormInput label="Nº RFA" name="numero_planilha" span={4} />
                        <FormInput label="Revisão" name="texto_revisao" span={4} />
                        <FormDatePicker
                          label="Data de Aprovação"
                          name="dataAprovacao"
                          format="DD/MM/YYYY"
                          span={4}
                          required
                        />
                        {selectedItem && hasPermission(['ORCADO_ECONOMICO_RFA_EDITAR_ABA_INDEX']) ? (
                          <UploadFile
                            hasFile={hasFile}
                            accept={'.xlsx'}
                            label="Incluir planilha"
                            id="importFilePlanilha"
                            selectedItem={selectedItem}
                          />
                        ) : (
                          <> </>
                        )}
                      </Widget>
                    </MasterDetailForm>
                  )}
                  {selectedItem ? (
                    <CrfPlanilhaRfaTabela
                      atualizarTelaProp={atualizarTela}
                      projeto={selectedItem}
                      hasPlanilha={hasPlanilhaRfa}
                    />
                  ) : (
                    <> </>
                  )}
                  {selectedItem &&
                    hasPermission(['ORCADO_ECONOMICO_RFA_VISUALIZAR_MENU']) &&
                    (planilhas && planilhas.length > 0) ? (
                    <CrfTablePlanilha dataPlanilhas={planilhas || []} handleClick={exportarPlanilha} />
                  ) : (
                    <> </>
                  )}
                </GridView>
              );
            }}
          </CrudContext.Consumer>
        )}
      </CompositeView>
    </CrudMasterDetailView>
  );
}

export default CrfPlanilhaRfa;
